import { render } from "./SldDiy.vue?vue&type=template&id=326da9ba&scoped=true"
import script from "./SldDiy.vue?vue&type=script&lang=js"
export * from "./SldDiy.vue?vue&type=script&lang=js"

import "./SldDiy.vue?vue&type=style&index=0&id=326da9ba&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326da9ba"]])

export default __exports__